import { render, staticRenderFns } from "./SchedulesReports.vue?vue&type=template&id=06396da4&scoped=true"
import script from "./SchedulesReports.vue?vue&type=script&lang=js"
export * from "./SchedulesReports.vue?vue&type=script&lang=js"
import style0 from "./SchedulesReports.vue?vue&type=style&index=0&id=06396da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06396da4",
  null
  
)

export default component.exports